import React from "react";
import { Instagram, Facebook, Linkedin, Twitter, ExternalLink, Globe } from "lucide-react";
import { NAV_LINKS } from "./data";
import { BrandLogo } from "./BrandLogo";
import { useSiteContent } from "../../context/SiteContent";

export const Footer = () => {
  const { content } = useSiteContent();
  const ci = content?.companyInfo || {};
  const social = content?.socialLinks || {};

  const SOCIAL = [
    { icon: Instagram, href: social.instagram, label: "Instagram" },
    { icon: Facebook, href: social.facebook, label: "Facebook" },
    { icon: Linkedin, href: social.linkedin, label: "LinkedIn" },
    { icon: Twitter, href: social.twitter, label: "X" },
  ].filter((s) => s.href);

  return (
    <footer className="bg-helios-slate text-slate-300 relative overflow-hidden" data-testid="footer">
      <div className="noise-overlay" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5"><BrandLogo dark size={30} src={ci.footerLogoUrl || ci.logoUrl} /></div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
              Engineering leaders in autonomous solar cleaning robotics &amp; comprehensive O&amp;M automation.
            </p>
            <p className="mt-4 font-mono text-[11px] text-slate-500">Founded 2022 · GST {ci.gstNumber}</p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500 mb-4">Explore</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}><a href={l.href} className="text-sm text-slate-300 hover:text-white transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500 mb-4">Catalog &amp; Profiles</p>
            <ul className="space-y-2.5">
              {social.webCatalog && <li><a href={social.webCatalog} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-catalog"><Globe size={13} /> Web Catalog</a></li>}
              {social.indiamart && <li><a href={social.indiamart} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-indiamart"><ExternalLink size={13} /> IndiaMART Profile</a></li>}
              <li><a href={`mailto:${ci.email}`} className="text-sm text-slate-300 hover:text-white transition-colors break-all">{ci.email}</a></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500 mb-4">Works Address</p>
            <p className="text-sm text-slate-400 leading-relaxed">{ci.worksAddress}</p>
            <div className="flex items-center gap-2.5 mt-5">
              {SOCIAL.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                  className="flex items-center justify-center w-9 h-9 rounded-full border border-white/15 text-slate-300 hover:bg-white hover:text-helios-slate transition-colors"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}><s.icon size={15} /></a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {ci.legalName}. All rights reserved.</p>
          <p className="font-mono text-[11px] text-slate-600">Rajkot · Gujarat · India</p>
        </div>
      </div>
    </footer>
  );
};
